import {Field, useFormikContext} from 'formik';

import {Grid, Input, Text} from '@mantine/core';

import {
    FormikTextInput
} from '@flexinet/ui-components';
import {User} from '../../types';

export const ContactPanel = () => {
    const {values} = useFormikContext<User>();

    return (
        <Grid p={'sm'} my={'sm'}>

            <Grid.Col span={12}>
                <Field
                    name='address'
                    label='Address'
                    description='Please enter address'
                    component={FormikTextInput}
                />
            </Grid.Col>

            <Grid.Col span={12}>
                <Field
                    name='website'
                    label='Website'
                    description='Please enter website'
                    component={FormikTextInput}
                />
            </Grid.Col>


            <Grid.Col span={6}>
                <Field
                    name='phoneNumber'
                    label='Phone Number'
                    description='Please enter phone number +17141234567'
                    component={FormikTextInput}
                />
            </Grid.Col>

            <Grid.Col span={6}>
                {/* Read-only (FNP-2015). users-api returns the STRING "false", which
                    a switch reads as on, and Directory never sends this field. */}
                <Input.Wrapper mt={'xl'} label='Phone Number is verified'>
                    <Text>{values.phoneNumberVerified === 'true' ? 'Yes' : 'No'}</Text>
                </Input.Wrapper>
            </Grid.Col>


        </Grid>

    )
}
